<script lang="ts">
  /** TBD: add options button */
  import PianoInstrument from '../../uTheory.Notation/pianoInstrument';
  import Tonicization from '../../uTheory.Notation/tonicization';
  import KeySignature from '../../uTheory.Notation/keySignature';
  import type Note from '../../uTheory.Notation/note';
  import { dichords } from './dichordGeneration';
  import UPrefs from '../uPrefs';
  import errorProvider from '../../errorProvider';
  import { toHTML } from '../../uTheory.Font/font';
  import type { SolfegeSystemName } from 'shared/definitions/musicTheory/solfegeAndScaleDegrees';

  console.log(dichords); // ok, yes, this pulls in the whole ordered object.

  const uPrefs = new UPrefs();

  export let system: SolfegeSystemName = 'solfegeDoMinor';
  export let modeName:
    | 'Major'
    | 'Natural Minor'
    | 'Harmonic Minor'
    | 'Natural and Harmonic Minor'
    | 'Natural and Melodic Minor' = 'Natural and Melodic Minor';

  /** set game state */
  let started = false;
  let lost = false;
  let lastNote = 'Do';
  /** Flag for aboutBox and settings */
  let aboutBox = false;
  /** number of recoverable errors allowed each game */
  let playerLives = 3;
  /** flag when player loses a life */
  let mistake = false;
  /** flag for whether user can select own options. Should be set by uTheory
   * based on teacher/admin prefs. */
  const allowOptions = true;
  /** Label for the about/settins button depending on whether user can
   * configure*/
  const settingsLabel = allowOptions ? 'Settings' : 'About';

  /** initialize mode */
  const modeOptions = [
    {
      notes: 7,
      name: 'Major',
      solfegeButtonsDo: ['DO', 'RE', 'MI', 'FA', 'SO', 'LA', 'TI'],
      solfegeButtonsLa: ['DO', 'RE', 'MI', 'FA', 'SO', 'LA', 'TI'],
      scaleDegreeButtons: ['1', '2', '3', '4', '5', '6', '7'],
    },
    {
      notes: 7,
      name: 'Natural Minor',
      solfegeButtonsDo: ['DO', 'RE', 'ME', 'FA', 'SO', 'LE', 'TE'],
      solfegeButtonsLa: ['LA', 'TI', 'DO', 'RE', 'MI', 'FA', 'SO'],
      scaleDegreeButtons: [
        toHTML('scaleDegree', '^1'),
        toHTML('scaleDegree', '^2'),
        toHTML('scaleDegree', '^3'),
        toHTML('scaleDegree', '^4'),
        toHTML('scaleDegree', '^5'),
        toHTML('symbol', 'down') + toHTML('scaleDegree', '^6'),
        toHTML('symbol', 'down') + toHTML('scaleDegree', '^7'),
      ],
    },
    {
      notes: 7,
      name: 'Harmonic Minor',
      solfegeButtonsDo: ['DO', 'RE', 'ME', 'FA', 'SO', 'LE', 'TI'],
      solfegeButtonsLa: ['LA', 'TI', 'DO', 'RE', 'MI', 'FA', 'SI'],
      scaleDegreeButtons: [
        toHTML('scaleDegree', '^1'),
        toHTML('scaleDegree', '^2'),
        toHTML('scaleDegree', '^3'),
        toHTML('scaleDegree', '^4'),
        toHTML('scaleDegree', '^5'),
        toHTML('symbol', 'down') + toHTML('scaleDegree', '^6'),
        toHTML('symbol', 'up') + toHTML('scaleDegree', '^7'),
      ],
    },
    {
      notes: 8,
      name: 'Natural and Harmonic Minor',
      solfegeButtonsDo: ['DO', 'RE', 'ME', 'FA', 'SO', 'LE', 'TE', 'TI'],
      solfegeButtonsLa: ['LA', 'TI', 'DO', 'RE', 'MI', 'FA', 'SO', 'SI'],
      scaleDegreeButtons: [
        toHTML('scaleDegree', '^1'),
        toHTML('scaleDegree', '^2'),
        toHTML('scaleDegree', '^3'),
        toHTML('scaleDegree', '^4'),
        toHTML('scaleDegree', '^5'),
        toHTML('symbol', 'down') + toHTML('scaleDegree', '^6'),
        toHTML('symbol', 'down') + toHTML('scaleDegree', '^7'),
        toHTML('symbol', 'up') + toHTML('scaleDegree', '^7'),
      ],
    },
    {
      notes: 9,
      name: 'Natural and Melodic Minor',
      solfegeButtonsDo: ['DO', 'RE', 'ME', 'FA', 'SO', 'LE', 'LA', 'TE', 'TI'],
      solfegeButtonsLa: ['LA', 'TI', 'DO', 'RE', 'MI', 'FA', 'FI', 'SO', 'SI'],
      scaleDegreeButtons: [
        toHTML('scaleDegree', '^1'),
        toHTML('scaleDegree', '^2'),
        toHTML('scaleDegree', '^3'),
        toHTML('scaleDegree', '^4'),
        toHTML('scaleDegree', '^5'),
        toHTML('symbol', 'down') + toHTML('scaleDegree', '^6'),
        toHTML('symbol', 'up') + toHTML('scaleDegree', '^6'),
        toHTML('symbol', 'down') + toHTML('scaleDegree', '^7'),
        toHTML('symbol', 'up') + toHTML('scaleDegree', '^7'),
      ],
    },
  ];

  let mode = modeOptions.find((m) => m.name === modeName);
  console.log({ mode });
  const player = new PianoInstrument();
  const tonicizer = new Tonicization(player);

  let majorNotes: Note[] = new KeySignature().scale.notes;
  let minorNotes: Note[] = new KeySignature().scale.notes;

  /** set the speed of playback in ms. */
  const speed = 800;
  /** how many notes there are in the currently active sequence from the player's perspective */
  let currentQuestionLength = 0;
  /** the notes in the current question -- these are shifted as they are answered */
  let currentQuestionNotes: Note[] = [];
  /** the current target sequence */
  let completeQuestionNotes: Note[] = [];
  let key: KeySignature;
  /** to prevent button pushes while sequence is playing. */
  let playing = false;
  /** initial playerLevel. Keep as number from 0 to 1. Must be minimum of about
   * 0.2 or there won't be sufficient choices. */
  let playerLevel = 0.25;
  /** eventually hook into a record of the user's high score. Use as proxy for user level? */
  let userHighScore = 0;
  // If a high score has been saved on the server, set it to that:
  uPrefs.setAppName('solfege-sally', undefined, errorProvider.error).then(() => {
    userHighScore = uPrefs.getPreference('userHighScore') || userHighScore;
  });
  console.log('uPrefs', uPrefs);

  /** Track the user's current score */
  let userScore = 0;
  /** Array of solfege syllables, (index is scale degree - 1) */
  const keypressNumbers = ['1', '2', '3', '4', '5', '6', '7']; // KEY PRESS OPTION WILL BREAK WITH MINOR

  /** also use these arrays to fill system choice */
  let buttonNames: Array<string>;
  let lastMinorNames: Array<string>;
  /** for display purposes */
  let systemName: string;

  /** if the system or mode is changed, we need to recalculate these. */
  function setNames() {
    if (system === 'solfegeDoMinor') {
      systemName = 'Solfege with Do Minor';
      buttonNames = mode.solfegeButtonsDo;
      lastMinorNames = ['DO', 'RE', 'ME', 'FA', 'SO', 'LE', 'TE'];
    } else if (system === 'solfegeLaMinor') {
      systemName = 'Solfege with La Minor';
      buttonNames = mode.solfegeButtonsLa;
      lastMinorNames = ['LA', 'TI', 'DO', 'RE', 'MI', 'FA', 'SO'];
    } else if (system === 'scaleDegrees') {
      systemName = 'Scale Degrees';
      buttonNames = mode.scaleDegreeButtons;
      lastMinorNames = [
        toHTML('scaleDegree', '^1'),
        toHTML('scaleDegree', '^2'),
        toHTML('scaleDegree', '^3'),
        toHTML('scaleDegree', '^4'),
        toHTML('scaleDegree', '^5'),
        toHTML('symbol', 'down') + toHTML('scaleDegree', '^6'),
        toHTML('symbol', 'down') + toHTML('scaleDegree', '^7'),
      ];
    }
  }
  /** Initial calculation */
  setNames();

  /**
   * enable keyboard input with scale degrees.
   */
  function handleKeydown(event: KeyboardEvent) {
    if (!(mode.notes === 7)) return;
    const keypress = event.key;
    if (keypressNumbers.includes(keypress)) {
      checkAnswer(Number(keypress));
    }
  }

  /**
   * This is triggered by player input.
   * Each note is checked against the current target note in the sequence
   * until failure, or until entire sequence has been played.
   * The latter triggers addition of one more note to sequence, and it is replayed.
   */
  function checkAnswer(scaleDegree: number, noteIsMinor?: boolean) {
    if (playing) return;

    const correctNote = currentQuestionNotes.shift();
    let playedNote: Note;
    if (!noteIsMinor) {
      playedNote = majorNotes[scaleDegree - 1];
    } else {
      playedNote = minorNotes[scaleDegree - 1];
    }

    /**
     * This is triggered by player input.
     * Each note is checked against the current target note in the sequence
     * until failure, or until entire sequence has been played.
     * The latter triggers addition of one more note to sequence, and it is replayed.
     */
    const isCorrect = correctNote.equalsIgnoreOctave(playedNote);

    console.log({ correctNote, playedNote, isCorrect });

    if (!isCorrect) {
      if (playerLives === 1) {
        playerLives = 0;
        if (majorNotes.includes(correctNote)) {
          lastNote = buttonNames[majorNotes.indexOf(correctNote) % 7];
        } else {
          lastNote = lastMinorNames[minorNotes.indexOf(correctNote) % 7];
        }

        lost = true;
        playDiesIrae();
        if (userScore > userHighScore) {
          userHighScore = userScore;
          uPrefs.setPreference('userHighScore', userHighScore);
          uPrefs.setPreference('userMaxLenth', currentQuestionLength); // only need to set each time a user reaches a high score.
        }
        return;
      }
      playerLives--;
      if (majorNotes.includes(correctNote)) {
        lastNote = buttonNames[majorNotes.indexOf(correctNote) % 7];
      } else {
        lastNote = lastMinorNames[minorNotes.indexOf(correctNote) % 7];
      }
      mistake = true;
      return;
    }
    userScore += 1;
    player.play(correctNote, { stopTime: speed / 1000 });

    // if there are still notes in the current question to answer, wait for them.
    if (currentQuestionNotes.length) return;

    chooseNewDichord();
    playSequence();
  }

  function randomizeKey() {
    lost = false; // restore game board
    playerLives = 3; // ensure playerLives restored
    userScore = 0;
    const accidentalCount = Math.floor(Math.random() * 12) - 4; // start by choosing a random key.
    key = new KeySignature(accidentalCount);
    console.log(`Key: ${key}`);
    const keyNote = key.keyNote;
    keyNote.octave = Math.floor(Math.random() * 2) + 3; // do we really want a two octave choice here?
    key.setTonic(keyNote);
    const minorKey = key.getParallelKey();
    minorKey.setTonic(keyNote);
    /** The majorNotes array is our range of possible notes in the game when in Major.
     *  refactored the code here to expand the set to two octaves
     */
    majorNotes = key.scale.notes.concat(
      [1, 2, 3, 4, 5, 6, 7].map((i) => key.scale.notes[i].getNoteAt('P8') as Note),
    );
    function convertToMinor(note: Note, i: number) {
      if ([2, 5, 6, 9, 12, 13].includes(i)) return note.getNoteAt('-A1') as Note;
      return note as Note;
    }
    minorNotes = majorNotes.map(convertToMinor);
    console.log({ majorNotes });
    console.log({ minorNotes });
    completeQuestionNotes = [];
    completeQuestionNotes[0] = majorNotes[7]; // sets middle of range as the tonic
    currentQuestionLength = 1; // clear the playback iterator;
    if (mode.name === 'Major') {
      return key;
    }
    key = minorKey;
    return key;
  }

  function timer(ms) {
    return new Promise((res) => setTimeout(res, ms));
  }

  /** or even better, if replaced with trombones? */
  async function playDiesIrae() {
    currentQuestionLength = 8;
    const diesIrae = [7, 6, 7, 5, 6, 4, 5, 5];
    for (let i = 0; i < 8; i++) {
      completeQuestionNotes[i] = majorNotes[diesIrae[i]];
    }
    playing = true;
    completeQuestionNotes.slice(0, currentQuestionLength).forEach((note, i) => {
      const playOptions = { startTime: (i * speed) / 1000, stopTime: ((i + 1) * speed) / 1000 };
      // console.log(playOptions, `${note}`);
      player.play(note, playOptions);
    });
    await timer(currentQuestionLength * speed);
    playing = false;
  }

  async function playSequence() {
    console.log('started playing');

    // new completeQuestionNotes.length is 1 on first pass.
    currentQuestionNotes = completeQuestionNotes.slice(0, currentQuestionLength);

    playing = true;

    if (currentQuestionLength === 1) {
      await tonicizer.tonicize(key, 100);
    }
    await timer(speed * 1.5);
    // We may not want to keep this if the questions get harder?
    const questionSpeed = speed / (currentQuestionLength / 7 + 6 / 7);
    completeQuestionNotes.slice(0, currentQuestionLength).forEach((note, i) => {
      // console.log(`playint ${note}`);
      const playOptions = {
        startTime: (i * questionSpeed) / 1000,
        stopTime: ((i + 1) * questionSpeed) / 1000,
      };
      // console.log(playOptions, `${note}`);
      player.play(note, playOptions);
    });
    await timer(currentQuestionLength * questionSpeed);

    console.log('stopped playing');
    playing = false;
  }

  /**
   * Called from end of checkAnswer, this adds a new note to the sequence
   * after the player has succeeded
   */
  function chooseNewDichord() {
    /** level based on difficulty from 0 to 1 */
    let dichordLevel = completeQuestionNotes.length / 80 + playerLevel;
    if (dichordLevel > 8) dichordLevel = 0.8; // to keep level in bounds (max10)
    console.log(`dichordLevel:${dichordLevel}`);
    const priorNote = completeQuestionNotes.slice(-1)[0];
    let priorNoteIndex: number;
    if (majorNotes.includes(priorNote)) priorNoteIndex = majorNotes.indexOf(priorNote);
    else priorNoteIndex = minorNotes.indexOf(priorNote);
    const priorScaleDegree = (priorNoteIndex % 7) + 1;
    /** calculate last interval, if there was one, as a distance (positive or negative) */
    let lastInterval: Number = 0;
    if (completeQuestionNotes.length > 1) {
      const prePriorNote = completeQuestionNotes.slice(-2)[0];
      let prePriorNoteIndex: number;
      if (majorNotes.includes(prePriorNote)) prePriorNoteIndex = majorNotes.indexOf(prePriorNote);
      else prePriorNoteIndex = minorNotes.indexOf(prePriorNote);
      lastInterval = priorNoteIndex - prePriorNoteIndex;
    }

    console.log(`prior Scale Degree:${priorScaleDegree}`);
    console.log(`Last Interval:${lastInterval}`);
    /** The options at the current difficulty level. */
    const dichordChoices = dichords.filter((dc) => {
      // Have to start from the note we just had
      if (dc.firstScaleDegree !== priorScaleDegree) return false;
      // No minors (if majorOrModal is true)
      // ONLY NEED TO FILTER SECOND NOTES! (first has just been filtered)
      if (mode.name === 'Major') {
        /** remove all minor scale degrees */
        if (dc.id.includes('m')) return false;
        /** remove all major third scale degrees */
      } else if (dc.id.slice(-1) === '3' && dc.id.slice(-2, -1) !== 'm') {
        return false;
      }
      if (mode.name === 'Natural Minor') {
        /** remove all major 6 and 7 scale degrees */
        if ((dc.id.slice(-1) === '6' || dc.id.slice(-1) === '7') && dc.id.slice(-2, -1) !== 'm') {
          return false;
        }
      } else if (mode.name === 'Harmonic Minor') {
        /** remove all major 6 scale degrees */
        if (dc.id.slice(-1) === '6' && dc.id.slice(-2, -1) !== 'm') return false;
        /** remove all minor 7 scale degrees */
        if (dc.id.includes('m7')) return false;
      } else if (mode.name === 'Natural and Harmonic Minor') {
        /** remove all major 6 scale degrees */
        if (dc.id.slice(-1) === '6' && dc.id.slice(-2, -1) !== 'm') return false;
      }

      // If it's too hard, nope! Still leaves all easier options.
      if (dc.difficulty >= dichordLevel) return false;

      /**
       * choose only elements where first scale degree equals prior, and
       * where second scale degree is within range. no option here for "same"
       * so there will be no repeated notes. (easily modified if desired.)
       */
      if (dc.direction === 'up') {
        if (lastInterval > 4) return false; // if large last interval, go other direction
        if (priorNoteIndex + dc.genericDistance > 15) return false;
        // out of range!
        return true; // going up is okay.
      }
      if (dc.direction === 'down') {
        if (lastInterval < -4) return false; // if large last interval, go other direction
        if (priorNoteIndex - dc.genericDistance < -1) return false;
        // out of range!
        return true; // going down is okay.
      }
      if (dc.direction === 'same') return false; // if interval is unison, nope!

      // This should never happen
      throw Error('dichord was not filtered correctly');
    });
    console.log(dichordChoices);
    const randomDichordIndex = Math.floor(Math.random() * dichordChoices.length);
    const nextDichord = dichordChoices[randomDichordIndex];
    console.log(nextDichord);
    let nextNote: Note;
    let thisIsMinor = false;
    if (nextDichord.id.slice(-2, -1) === 'm') thisIsMinor = true;
    console.log({ Minor: thisIsMinor });

    if (nextDichord.direction === 'up') {
      if (!thisIsMinor) nextNote = majorNotes[priorNoteIndex + nextDichord.genericDistance - 1];
      else nextNote = minorNotes[priorNoteIndex + nextDichord.genericDistance - 1];
    }
    if (nextDichord.direction === 'down') {
      if (!thisIsMinor) nextNote = majorNotes[priorNoteIndex - nextDichord.genericDistance + 1];
      else nextNote = minorNotes[priorNoteIndex - nextDichord.genericDistance + 1];
    }

    completeQuestionNotes.push(nextNote);
    currentQuestionLength++; // increment user question length
  }

  // START sequence. Triggered by start button
  function start() {
    if (playing) return;
    randomizeKey();
    playSequence();
  }

  function depressButtonOnTouch(evt: Event) {
    (evt.target as HTMLButtonElement).classList.add('active');
    evt.preventDefault();
  }

  function releaseButtonOnTouchEnd(evt: Event) {
    (evt.target as HTMLButtonElement).classList.remove('active');
  }
</script>

<svelte:body on:keydown={handleKeydown} />

<div class="container">
  <div class="interface">
    {#if !aboutBox}
      <button
        class="about"
        on:click={() => {
          aboutBox = true;
        }}
        disabled={playing}>{settingsLabel}</button
      >
    {/if}
    <div class="bigCircle" />
    <div class="logo">Solfege Sally</div>
    <button
      id="D"
      class="circle"
      disabled={playing}
      on:touchend={releaseButtonOnTouchEnd}
      on:touchstart={(evt) => {
        depressButtonOnTouch(evt);
        checkAnswer(1);
      }}
      on:mousedown={() => checkAnswer(1)}>{@html buttonNames[0]}</button
    >
    <button
      id="R"
      class="circle"
      disabled={playing}
      on:touchend={releaseButtonOnTouchEnd}
      on:touchstart={(evt) => {
        depressButtonOnTouch(evt);
        checkAnswer(2);
      }}
      on:mousedown={() => checkAnswer(2)}>{@html buttonNames[1]}</button
    >
    {#if mode.name === 'Major'}
      <button
        id="M"
        class="circle"
        disabled={playing}
        on:touchend={releaseButtonOnTouchEnd}
        on:touchstart={(evt) => {
          depressButtonOnTouch(evt);
          checkAnswer(3);
        }}
        on:mousedown={() => checkAnswer(3)}>{@html buttonNames[2]}</button
      >
    {:else}
      <button
        id="M"
        class="circle"
        disabled={playing}
        on:touchend={releaseButtonOnTouchEnd}
        on:touchstart={(evt) => {
          depressButtonOnTouch(evt);
          checkAnswer(3, true);
        }}
        on:mousedown={() => checkAnswer(3, true)}>{@html buttonNames[2]}</button
      >
    {/if}
    <button
      id="F"
      class="circle"
      disabled={playing}
      on:touchend={releaseButtonOnTouchEnd}
      on:touchstart={(evt) => {
        depressButtonOnTouch(evt);
        checkAnswer(4);
      }}
      on:mousedown={() => checkAnswer(4)}>{@html buttonNames[3]}</button
    >
    <button
      id="S"
      class="circle"
      disabled={playing}
      on:touchend={releaseButtonOnTouchEnd}
      on:touchstart={(evt) => {
        depressButtonOnTouch(evt);
        checkAnswer(5);
      }}
      on:mousedown={() => checkAnswer(5)}>{@html buttonNames[4]}</button
    >
    {#if mode.name === 'Major'}
      <button
        id="L"
        class="circle"
        disabled={playing}
        on:touchend={releaseButtonOnTouchEnd}
        on:touchstart={(evt) => {
          depressButtonOnTouch(evt);
          checkAnswer(6);
        }}
        on:mousedown={() => checkAnswer(6)}>{@html buttonNames[5]}</button
      >
      <button
        id="T"
        class="circle"
        disabled={playing}
        on:touchend={releaseButtonOnTouchEnd}
        on:touchstart={(evt) => {
          depressButtonOnTouch(evt);
          checkAnswer(7);
        }}
        on:mousedown={() => checkAnswer(7)}>{@html buttonNames[6]}</button
      >
    {:else if mode.name === 'Natural Minor'}
      <button
        id="L"
        class="circle"
        disabled={playing}
        on:touchend={releaseButtonOnTouchEnd}
        on:touchstart={(evt) => {
          depressButtonOnTouch(evt);
          checkAnswer(6, true);
        }}
        on:mousedown={() => checkAnswer(6, true)}>{@html buttonNames[5]}</button
      >
      <button
        id="T"
        class="circle"
        disabled={playing}
        on:touchend={releaseButtonOnTouchEnd}
        on:touchstart={(evt) => {
          depressButtonOnTouch(evt);
          checkAnswer(7, true);
        }}
        on:mousedown={() => checkAnswer(7, true)}>{@html buttonNames[6]}</button
      >
    {:else if mode.name === 'Harmonic Minor'}
      <button
        id="L"
        class="circle"
        disabled={playing}
        on:touchend={releaseButtonOnTouchEnd}
        on:touchstart={(evt) => {
          depressButtonOnTouch(evt);
          checkAnswer(6, true);
        }}
        on:mousedown={() => checkAnswer(6, true)}>{@html buttonNames[5]}</button
      >
      <button
        id="T"
        class="circle"
        disabled={playing}
        on:touchend={releaseButtonOnTouchEnd}
        on:touchstart={(evt) => {
          depressButtonOnTouch(evt);
          checkAnswer(7);
        }}
        on:mousedown={() => checkAnswer(7)}>{@html buttonNames[6]}</button
      >
    {:else if mode.name === 'Natural and Harmonic Minor'}
      <button
        id="L"
        class="circle"
        disabled={playing}
        on:touchend={releaseButtonOnTouchEnd}
        on:touchstart={(evt) => {
          depressButtonOnTouch(evt);
          checkAnswer(6, true);
        }}
        on:mousedown={() => checkAnswer(6, true)}>{@html buttonNames[5]}</button
      >
      <button
        id="TE"
        class="circle half bottom"
        disabled={playing}
        on:touchend={releaseButtonOnTouchEnd}
        on:touchstart={(evt) => {
          depressButtonOnTouch(evt);
          checkAnswer(7, true);
        }}
        on:mousedown={() => checkAnswer(7, true)}>{@html buttonNames[6]}</button
      >
      <button
        id="TI"
        class="circle half top"
        disabled={playing}
        on:touchend={releaseButtonOnTouchEnd}
        on:touchstart={(evt) => {
          depressButtonOnTouch(evt);
          checkAnswer(7);
        }}
        on:mousedown={() => checkAnswer(7)}>{@html buttonNames[7]}</button
      >
    {:else if mode.name === 'Natural and Melodic Minor'}
      <button
        id="LE"
        class="circle half bottom"
        disabled={playing}
        on:touchend={releaseButtonOnTouchEnd}
        on:touchstart={(evt) => {
          depressButtonOnTouch(evt);
          checkAnswer(6, true);
        }}
        on:mousedown={() => checkAnswer(6, true)}>{@html buttonNames[5]}</button
      >
      <button
        id="LA"
        class="circle half top"
        disabled={playing}
        on:touchend={releaseButtonOnTouchEnd}
        on:touchstart={(evt) => {
          depressButtonOnTouch(evt);
          checkAnswer(6);
        }}
        on:mousedown={() => checkAnswer(6)}>{@html buttonNames[6]}</button
      >
      <button
        id="TE"
        class="circle half bottom"
        disabled={playing}
        on:touchend={releaseButtonOnTouchEnd}
        on:touchstart={(evt) => {
          depressButtonOnTouch(evt);
          checkAnswer(7, true);
        }}
        on:mousedown={() => checkAnswer(7, true)}>{@html buttonNames[7]}</button
      >
      <button
        id="TI"
        class="circle half top"
        disabled={playing}
        on:touchend={releaseButtonOnTouchEnd}
        on:touchstart={(evt) => {
          depressButtonOnTouch(evt);
          checkAnswer(7);
        }}
        on:mousedown={() => checkAnswer(7)}>{@html buttonNames[8]}</button
      >
    {/if}
    <div class="info playerLives">Lives: {playerLives}</div>
    <div class="info displayScore">Score: {userScore}</div>
    <div class="info displayHighScore">HighScore: {userHighScore}</div>
    {#if !started}
      <div class="bigCircle hide" />
      <button
        class="startButton"
        on:click={() => {
          started = true;
          start();
        }}>Start Game</button
      >
    {/if}
    {#if mistake}
      <div class="bigCircle hide" />
      <button
        class="startButton explain"
        on:click={() => {
          mistake = false;
          playSequence();
        }}
        >Oops!<br />The next note was<br />{@html lastNote}!<br />(Click to repeat sequence)</button
      >
    {/if}
    {#if lost}
      <div class="bigCircle hide" />
      {#if playing}
        <button class="startButton explain"
          >Game Over!<br />The next note was<br />{@html lastNote}!<br />Let us briefly<br />mourn
          our loss</button
        >
      {:else}
        <button
          class="startButton"
          on:click={() => {
            started = true;
            start();
          }}>Play Again!</button
        >
      {/if}
    {/if}
    {#if aboutBox}
      <div class="aboutHide" />
      {#if allowOptions}
        <div class="makeItPretty">
          <label for="select1">Scale Choice</label>
          <select class="modeSelect" id="select1" bind:value={mode}>
            {#each modeOptions as modeOption}
              <option value={modeOption}>{modeOption.name}</option>
            {/each}
          </select>

          <label for="select2">System Choice</label>
          <select class="systemSelect" id="select2" bind:value={system}>
            <option value="scaleDegrees">Scale Degrees</option>
            <option value="solfegeDoMinor">Solfege with Do Minor</option>
            <option value="solfegeLaMinor">Solfege with La Minor</option>
          </select>

          <label for="select3">Change Player Level</label>
          <select class="systemSelect" id="select3" bind:value={playerLevel}>
            <option value="0.25">Jedi Recruit</option>
            <option value="0.35">Jedi Initiate</option>
            <option value="0.45">Padawan</option>
            <option value="0.55">Jedi Adept</option>
            <option value="0.65">Jedi Knight</option>
            <option value="0.75">Jedi Master</option>
            <option value="0.85">Jedi Lord</option>
            <option value="0.95">Jedi Consular</option>
          </select>
          <button
            class="settingsButton"
            on:click={() => {
              aboutBox = false;
              setNames();
              started = true;
              start();
            }}
            disabled={playing}>Start New Game with These Options</button
          >
        </div>{:else}
        <div class="makeItPretty">
          <div class="modePresent">
            Your current mode of gameplay is:<br />
            <div class="modeName">{mode.name}</div>
          </div>
          <div class="modePresent">
            Your current solmization system is:<br />
            <div class="modeName">{systemName}</div>
          </div>
          <button
            class="settingsButton"
            on:click={() => {
              aboutBox = false;
            }}
            disabled={playing}>Back to Game</button
          >
        </div>
      {/if}
    {/if}
  </div>
</div>

<style>
  @import url('https://fonts.googleapis.com/css2?family=Orelega+One&display=swap');

  .container {
    position: relative;
    width: 100%;
  }

  .interface {
    --diameter: min(90vw, 90vh);
    width: var(--diameter);
    height: var(--diameter);
    position: relative;
    margin: auto; /* Will not center vertically and won't work in IE6/7. */
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .startButton {
    position: absolute;
    top: 53%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    background-image: radial-gradient(yellow, orange);
    color: black;
    width: calc(var(--diameter) * 0.55);
    height: calc(var(--diameter) * 0.55);
    border-radius: 50%;
    text-align: center;
    font-family: 'Orelega One', serif;
    font-size: calc(var(--diameter) * 0.13);
    /* This is needed to unset a tailwind setting */
    line-height: normal;
    border: none;
    cursor: pointer;
    padding: 0;
    border-radius: 50%;
    text-align: center;
  }
  .startButton.explain {
    background-image: radial-gradient(rgb(0, 17, 172), rgb(54, 94, 182));
    color: white;
    font-size: calc(var(--diameter) * 0.06);
  }
  .circle {
    width: calc(var(--diameter) * 0.25);
    height: calc(var(--diameter) * 0.25);
    border-radius: 50%;
    text-align: center;
    font-family: 'Orelega One', serif;
    font-size: calc(var(--diameter) * 0.15);
    line-height: calc(var(--diameter) * 0.25);

    transition:
      filter 1s,
      transform 0.05s,
      text-shadow 0.1s;

    padding: 0;
    border: none;
    outline: none;
  }
  .circle.half {
    height: calc(var(--diameter) * 0.125);
    font-size: calc(var(--diameter) * 0.09);
    line-height: calc(var(--diameter) * 0.125);
    border-radius: 0%;
  }
  .circle.half.bottom {
    border-bottom-left-radius: calc(var(--diameter) * 0.25);
    border-bottom-right-radius: calc(var(--diameter) * 0.25);
  }
  .circle.half.top {
    border-top-left-radius: calc(var(--diameter) * 0.25);
    border-top-right-radius: calc(var(--diameter) * 0.25);
  }
  .circle:hover:not(:disabled) {
    cursor: pointer;
    transform: scale(1.05);
    text-shadow: 0px 0px 6px white;
  }
  .circle:active:not(:disabled),
  :global(.circle.active:not(:disabled)) {
    transform: scale(1);
    color: #dddddd;
  }
  .circle:disabled {
    filter: brightness(30%);
  }
  /* .circle.active {
     color: orange;
  }*/
  .bigCircle {
    width: calc(var(--diameter) * 0.9);
    height: calc(var(--diameter) * 0.9);
    border-radius: 50%;
    background: black;
    position: absolute;
    top: calc(var(--diameter) * 0.075);
    left: calc(var(--diameter) * 0.05);
  }
  .bigCircle.hide {
    opacity: 0.5;
  }
  .aboutHide {
    position: absolute;
    top: 0;
    left: 0;
    width: calc(var(--diameter));
    height: calc(var(--diameter));
    background: ivory;
    opacity: 0.95;
  }
  .makeItPretty {
    position: absolute;
    top: 0%;
    left: 0%;
    width: 70%;
    height: 70%;
    border: calc(var(--diameter) * 0.05) solid blue;
    border-radius: 5%;
    margin: calc(var(--diameter) * 0.05);
    padding: calc(var(--diameter) * 0.05);
    color: black;
    font-family: 'Orelega One', serif;
    font-size: calc(var(--diameter) * 0.045);
    line-height: calc(var(--diameter) * 0.045);
  }
  .settingsButton {
    position: absolute;
    top: 90%;
    left: 50%;
    transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    width: calc(var(--diameter) * 0.6);
    height: calc(var(--diameter) * 0.12);
    color: black;
    font-family: 'Orelega One', serif;
    font-size: calc(var(--diameter) * 0.045);
    line-height: calc(var(--diameter) * 0.045);
  }
  .logo {
    position: absolute;
    text-align: center;
    top: calc(var(--diameter) * 0.45);
    left: calc(var(--diameter) * 0.35);
    width: min-content;
    display: block;
    color: white;
    font-family: 'Orelega One', serif;
    font-size: calc(var(--diameter) * 0.1);
    line-height: calc(var(--diameter) * 0.075);
  }

  #D {
    background: #ff5050;
    position: absolute;
    top: calc(var(--diameter) * 0.1);
    left: calc(var(--diameter) * 0.375);
  }
  #R {
    background: #ff9999;
    position: absolute;
    top: calc(var(--diameter) * 0.212);
    left: calc(var(--diameter) * 0.61);
  }
  #M {
    background: #50f050;
    position: absolute;
    top: calc(var(--diameter) * 0.467);
    left: calc(var(--diameter) * 0.665);
  }
  #F {
    background: #6060ff;
    position: absolute;
    top: calc(var(--diameter) * 0.67);
    left: calc(var(--diameter) * 0.505);
  }
  #S {
    background: #ffa23a;
    position: absolute;
    top: calc(var(--diameter) * 0.67);
    left: calc(var(--diameter) * 0.245);
  }
  #L {
    background: #ff60a8;
    position: absolute;
    top: calc(var(--diameter) * 0.467);
    left: calc(var(--diameter) * 0.082);
  }
  #T {
    background: #f0f000;
    position: absolute;
    top: calc(var(--diameter) * 0.212);
    left: calc(var(--diameter) * 0.14);
  }
  #LE {
    background: #bf5eff;
    position: absolute;
    top: calc(var(--diameter) * 0.592);
    left: calc(var(--diameter) * 0.082);
  }
  #LA {
    background: #ff60a8;
    position: absolute;
    top: calc(var(--diameter) * 0.467);
    left: calc(var(--diameter) * 0.082);
  }
  #TE {
    background: #ffd07a;
    position: absolute;
    top: calc(var(--diameter) * 0.337);
    left: calc(var(--diameter) * 0.14);
  }
  #TI {
    background: #f0f000;
    position: absolute;
    top: calc(var(--diameter) * 0.212);
    left: calc(var(--diameter) * 0.14);
  }
  .info {
    position: absolute;
    padding: 0;
    text-align: left;
    width: min-content;
    display: block;
    color: black;
    font-family: 'Orelega One', serif;
    font-size: calc(var(--diameter) * 0.045);
    line-height: calc(var(--diameter) * 0.045);
  }
  .about {
    position: absolute;
    padding: 0;
    width: calc(var(--diameter) * 0.24);
    height: calc(var(--diameter) * 0.05);
    padding-left: 0;
    padding-right: 0;
    color: black;
    font-family: 'Orelega One', serif;
    font-size: calc(var(--diameter) * 0.045);
    line-height: calc(var(--diameter) * 0.045);
    top: calc(var(--diameter) * 0.09);
    left: calc(var(--diameter) * 0);
  }
  .info.playerLives {
    top: calc(var(--diameter) * 0.09);
    left: calc(var(--diameter) * 0.87);
  }
  .info.displayScore {
    top: calc(var(--diameter) * 0.9);
    left: calc(var(--diameter) * 0.87);
  }
  .info.displayHighScore {
    top: calc(var(--diameter) * 0.9);
    left: calc(var(--diameter) * 0);
  }
  .modeSelect {
    margin: 5%;
    color: black;
    font-family: 'Orelega One', serif;
    font-size: calc(var(--diameter) * 0.045);
    line-height: calc(var(--diameter) * 0.045);
  }
  .systemSelect {
    margin: 5%;
    color: black;
    font-family: 'Orelega One', serif;
    font-size: calc(var(--diameter) * 0.045);
    line-height: calc(var(--diameter) * 0.045);
  }
  .modePresent {
    margin: 5%;
    color: black;
    font-family: 'Orelega One', serif;
    font-size: calc(var(--diameter) * 0.05);
    line-height: calc(var(--diameter) * 0.05);
  }
  .modeName {
    margin: 5%;
    font-size: calc(var(--diameter) * 0.06);
    line-height: calc(var(--diameter) * 0.06);
  }
</style>
